import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import fromDtoToPermissionCategories from 'dto/access/fromDtoToPermissionCategories.dto';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const abeCustomPermissions = actionEndpointBe(
  'abeCustomPermissions',
  H.get,
  'salon/v2/:salonId/custom_permissions/list/',
  {
    inert: false,
    fromDto: fromDtoToPermissionCategories,
    umsg: UMSG_TYPE.global,
  },
);

export const ibeCustomPermissions = actionEndpointBe(
  'ibeCustomPermissions',
  H.get,
  'salon/v2/:salonId/custom_permissions/list/',
  {
    inert: true,
    fromDto: fromDtoToPermissionCategories,
    umsg: UMSG_TYPE.global,
  },
);
